export const getShortDateString = (date: Date): string => {
  let dateString = '';
  dateString += date.getMonth() + 1 + '/';
  dateString += date.getDate() + '/';
  dateString += date.getFullYear();

  return dateString;
};
